module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relatePr"
  }, [_c('p', [_vm._v("相关产品推荐")]), _vm._v(" "), _vm._l((_vm.relatedProducts), function(item, key, index) {
    return _c('ul', {
      class: {
        active: !_vm.actives[index]
      }
    }, [_c('h2', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.toggle(index)
        }
      }
    }, [_c('span', {
      staticClass: "h2_icon"
    }, [(!_vm.actives[index]) ? _c('i', [_c('img', {
      attrs: {
        "src": "//v3.cdn.qiyewan.com/jia.png",
        "alt": "add_icon"
      }
    })]) : _c('i', [_c('img', {
      attrs: {
        "src": "//v3.cdn.qiyewan.com/jian.png",
        "alt": "sub_icon"
      }
    })])]), _vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((item), function(p, p_index) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: 'product-detail',
            params: {
              serialId: p.serialId
            }
          },
          "param": ""
        }
      }, [_vm._v(_vm._s(p.name))])], 1)
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fa9a0d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/RelatedProducts.vue
// module id = 1018
// module chunks = 40